import { useEffect, useState } from 'react';

export function prefersReducedMotion() {
  return (
    typeof window !== 'undefined' &&
    Boolean(window.matchMedia?.('(prefers-reduced-motion: reduce)').matches)
  );
}

/** Counter that advances every `everyMs` (paused for people who reduce motion). */
export function useTicker(steps: number, everyMs: number) {
  const [step, setStep] = useState(0);
  useEffect(() => {
    if (prefersReducedMotion()) return;
    const id = window.setInterval(() => setStep((n) => (n + 1) % steps), everyMs);
    return () => window.clearInterval(id);
  }, [steps, everyMs]);
  return step;
}
